import { Box, Container, Stack, Typography } from "@mui/material";
import { AboutUsBg } from "assets";
import PrimaryButton from "components/PrimaryButton/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { globalStyle } from "themes/global.styles";
import theme, { responsiveFontSize } from "themes/Theme";

const AboutUsSection = () => {
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    navigate("/auth/signup");
  };
  return (
    <Container sx={styles.container}>
      <center>
        <Typography sx={globalStyle.sectionHeading}>
          About<span>us</span>
        </Typography>
      </center>
      <center>
        <Typography sx={globalStyle.sectionSubheading}>
          Greener Transactions Powered by Blockchain Innovation
        </Typography>
      </center>
      <Stack direction={{ xs: "column", md: "row" }} gap={2} mt={4}>
        <Box
          component={"img"}
          src={AboutUsBg}
          alt="about us image"
          sx={styles.sectionImage}
        />
        <Box>
          <Typography sx={styles.sectionDescription}>
            ERC Webwellet is a secure digital wallet designed exclusively for
            the Carbon Plant Project. Built on blockchain technology, it
            facilitates the storage, transfer, and management of Emission
            Reduction Coins (ERCs). With a focus on eco-conscious finance, our
            wallet enables individuals and organizations to actively participate
            in carbon emission reduction initiatives while enjoying seamless
            crypto transactions.
          </Typography>
          <Box sx={styles.actionBtnContainer}>
            <PrimaryButton title="Join Now" onClick={handleJoinNowClick} />
          </Box>
        </Box>
      </Stack>
    </Container>
  );
};
export default AboutUsSection;
const styles = {
  container: {
    py: 6,
  },
  sectionImage: {
    width: "50%",
    height: "auto",
    objectFit: "cover",
  },
  sectionTitle: {
    color: theme.palette.text.primary,
    fontSize: responsiveFontSize(56),
    fontWeight: 400,
    lineHeight: 1,
    textAlign: "right",
    marginBottom: "0.5em",
    "& span": {
      color: theme.palette.primary.main,
    },
  },
  sectionDescription: {
    color: theme.palette.text.primary,
    fontSize: responsiveFontSize(14),
    fontWeight: 400,
    textAlign: "justify",
  },
  actionBtnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 2,
    marginTop: "2em",
  },
};
